import { render, staticRenderFns } from "./AddContractProductie.vue?vue&type=template&id=efd94d96&scoped=true"
import script from "./AddContractProductie.vue?vue&type=script&lang=js"
export * from "./AddContractProductie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd94d96",
  null
  
)

export default component.exports